import { Dispatch } from 'redux';

import { post, RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AppState } from '../reducers';
import { getRequestHeaders } from './tools';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;
type SendFeedbackResponse = boolean;

export interface FormTypeFeedback {
    feedbackMessage: string;
}

export interface SendFeedbackStartedAction extends Action<typeof actionTypes.SEND_FEEDBACK_STARTED> {
    type: typeof actionTypes.SEND_FEEDBACK_STARTED;
}

export interface SendFeedbackFulfilledAction extends Action<typeof actionTypes.SEND_FEEDBACK_FULFILLED> {
    type: typeof actionTypes.SEND_FEEDBACK_FULFILLED;
    payload: SendFeedbackResponse;
}

export interface SendFeedbackFailedAction extends Action<typeof actionTypes.SEND_FEEDBACK_FAILED> {
    type: typeof actionTypes.SEND_FEEDBACK_FAILED;
    payload: RequestExceptionWithResponse;
}

export type FeedbackActions = SendFeedbackStartedAction | SendFeedbackFulfilledAction | SendFeedbackFailedAction;

export const sendFeedbackStarted = (): SendFeedbackStartedAction => ({
    type: actionTypes.SEND_FEEDBACK_STARTED,
});
export const sendFeedbackFulfilled = (json: SendFeedbackResponse): SendFeedbackFulfilledAction => ({
    type: actionTypes.SEND_FEEDBACK_FULFILLED,
    payload: json,
});
export const sendFeedbackFailed = (error: RequestExceptionWithResponse): SendFeedbackFailedAction => ({
    type: actionTypes.SEND_FEEDBACK_FAILED,
    payload: error,
});

export const sendFeedback =
    (form: FormTypeFeedback) =>
    async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
        const { bankregnr } = getState().context.config;
        const { loader, completion } = getState();
        const { hasSentFeedback, isSendingFeedback } = loader;

        const data = {
            content: form.feedbackMessage,
            preViewCaseId: completion.ongoing.applicationId,
        };

        if (!hasSentFeedback && !isSendingFeedback) {
            try {
                dispatch(sendFeedbackStarted());
                const response: SendFeedbackResponse = await post(
                    `${actionTypes.RESOURCE_PATH}/application/feedback`,
                    data,
                    getRequestHeaders(bankregnr),
                );
                dispatch(sendFeedbackFulfilled(response));
            } catch (error) {
                dispatch(sendFeedbackFailed(error));
            }
        }
    };
